/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Video from 'components/Video/Video';
import './Interview.scss';

/**
 * This is the Interview component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Interview({ layout, category, heading, intro, video }) {
  function renderText() {
    return (
      <div className="text">
        <small className="stamp" stagger-text="true">
          {category}
        </small>
        <h2 dangerouslySetInnerHTML={{ __html: heading }} stagger-text="true" />
        <p dangerouslySetInnerHTML={{ __html: intro }} appear="true" />
      </div>
    );
  }

  if (layout === 'right') {
    return (
      <div className="block interview layout-right">
        {renderText()}
        <div className="video-container" appear="true">
          <Video {...video} />
        </div>
      </div>
    );
  }

  return (
    <div className="block interview layout-left">
      <div className="video-container" appear="true">
        <Video {...video} />
      </div>
      {renderText()}
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Interview.propTypes = {
  layout: PropTypes.oneOf(['left', 'right']).isRequired,
  category: PropTypes.string,
  heading: PropTypes.string,
  intro: PropTypes.string,
  video: PropTypes.object.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Interview.defaultProps = {
  layout: 'left',
  video: {},
};

export default Interview;
